import { STATUS_KO, type Role, type UserStatus } from '../api/auth';

/**
 * 역할 명칭의 단일 출처 (리뷰 5회차 m21 — 「뷰어/작업자」와 「열람자/운영자」가 화면마다 달랐다).
 * 배지·select 옵션·감사 기록·403 안내가 모두 이것을 쓴다.
 */
export const ROLE_KO: Record<Role, string> = { viewer: '열람자', operator: '운영자', admin: '관리자' };

/** 역할 배지 — 색만이 아니라 글자로 구분한다. */
export function RoleBadge({ role }: { role: Role }) {
  // class 를 role-admin 으로 — 'admin' 은 관리자 페이지 컨테이너(.admin) 규칙과 충돌한다
  return <span className={`role-badge role-${role}`}>{ROLE_KO[role] ?? role}</span>;
}

/** 계정 상태 배지. */
export function StatusBadge({ status }: { status: UserStatus }) {
  return <span className={`status-badge ${status}`}>{STATUS_KO[status] ?? status}</span>;
}
